import { type FC, type ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import { OFFER_PROMOTION_TYPE } from '../../../../../../offer'
import { ProductHeadGenericLabel } from '../../../../../../product'
import { ProductHeadGenericLinkLabel } from '../../ProductHeadGenericLabel/ProductHeadGenericLinkLabel'
import { type ProductHeadLabel } from '../../ProductHeadLabelsTypes'

const getPromotionTypeByLabel = (
  promotionType: OFFER_PROMOTION_TYPE,
  dataQaId?: string,
): ReactElement | null => {
  switch (promotionType) {
    case OFFER_PROMOTION_TYPE.FREEBIE: {
      return (
        <ProductHeadGenericLabel
          className="border-dark-brand bg-light-primary-low text-dark-brand"
          data-qa-id={dataQaId}
        >
          <FormattedMessage id="general.label.product.freebie" />
        </ProductHeadGenericLabel>
      )
    }
    case OFFER_PROMOTION_TYPE.ONE_FOR_ONE: {
      return (
        <ProductHeadGenericLabel
          className="border-dark-brand bg-light-primary-low text-dark-brand"
          data-qa-id={dataQaId}
        >
          <FormattedMessage id="general.label.product.oneforone" />
        </ProductHeadGenericLabel>
      )
    }
    case OFFER_PROMOTION_TYPE.ONE_PLUS_ONE: {
      return (
        <ProductHeadGenericLinkLabel
          className="border border-dark-primary-min text-dark-primary-max hover:text-dark-hover-brand"
          data-qa-id={dataQaId}
          href="#pflichtangabe"
        >
          <FormattedMessage id="general.label.product.oneforone" />
        </ProductHeadGenericLinkLabel>
      )
    }
    default: {
      return null
    }
  }
}

export const ProductHeadPromotionLabelRenderer: FC<{
  'data-qa-id'?: string
  label: ProductHeadLabel
}> = ({ 'data-qa-id': dataQaId, label }) => {
  const promotionType = label.promotionSpecific?.promotionType

  if (!promotionType) {
    return null
  }

  return getPromotionTypeByLabel(promotionType, dataQaId)
}
